import { registerLazyPopupRenderer } from "@/entities/bottom-popup"

registerLazyPopupRenderer("age-gate", () => import("../ui/age-gate-popup"))
registerLazyPopupRenderer(
	"age-mismatch",
	() => import("../ui/age-mismatch-popup"),
)
